import React from "react";
import { Link } from "gatsby";
import Icon from "../assets/svg/chevron_right.inline.svg";

const CircleButton = ({ url, classList }) => {
  return (
    <Link to={url} className={`circle-button ${classList}`}>
      <Icon />
    </Link>
  );
};

export default CircleButton;
